(function () {
  const host = window.location.hostname.toLowerCase();
  const scriptsByDomain = {
    "empowerinstitutional.com": [
      {
        src: "https://cdn.cookielaw.org/consent/b7d8177b-6064-43fa-b886-691f591aa609/OtAutoBlock.js"
      },
      {
        src: "https://cdn.cookielaw.org/consent/b7d8177b-6064-43fa-b886-691f591aa609/otSDKStub.js",
        domain_script: "b7d8177b-6064-43fa-b886-691f591aa609",
      },
      {
        inline: "function OptanonWrapper() { }",
      },
    ],
  };
  const defaultScripts = [
    {
      src: "https://cdn.cookielaw.org/consent/b7d8177b-6064-43fa-b886-691f591aa609-test/OtAutoBlock.js",
    },
    {
      src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
      domain_script: "b7d8177b-6064-43fa-b886-691f591aa609-test",
    },
    {
      inline: "function OptanonWrapper() { }",
    },
  ];
  const scriptsToLoad = scriptsByDomain[host] || defaultScripts;
  const head = document.head;

  head.appendChild(document.createComment(` OneTrust Cookies Consent Notice start for ${host} ` ));
  scriptsToLoad.forEach((item) => {
    const script = document.createElement("script");
    if (item.src) {
      script.src = item.src;
      script.type = "text/javascript";
      script.async = false;
      if (item.domain_script) {
        script.dataset.domainScript = item.domain_script;
      }
    } else if (item.inline) {
      script.type = "text/javascript";
      script.textContent = item.inline;
    }
    document.head.appendChild(script);
  });
  head.appendChild(document.createComment(` OneTrust Cookies Consent Notice end for ${host} ` ));
})();
